import { z } from 'zod';
import type { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

/** Shared by the single-document and bulk apply-date modals so both reject the same way. */
export const createApplyDateSchema = (tMipManage: ReturnType<typeof useTranslationMipManage>) =>
	z.object({
		effectiveDate: z.date({
			required_error: tMipManage('documents_page.apply_date.modal.date_required'),
			invalid_type_error: tMipManage('documents_page.apply_date.modal.date_required'),
		}),
	});
